
import Vue, { PropType } from 'vue';

export default Vue.extend({
    name: 'InfoBox',
    props: {
        type: {
            type: String as PropType<'blue' | 'yellow'>,
            default: 'blue',
        },
    },
});
